/**
 * MainPage Content Service
 */

DM.Service.Content = (function () {
    return {
        getContent: function (forcePreviewParam) {
            var endpoint = 'home/content';
            var param = forcePreviewParam || '';
            return fetch(endpoint + param).then(response => response.json());
        }
    };
})();
